import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import styled from "styled-components";

class Table extends Component {
  state = {};

  render() {
    const { data, columns, pageSize } = this.props;

    //console.log(columns);
    return (
      <TableContainer>
        <ReactTable
          data={data}
          columns={columns}
          pageSize={pageSize}
          className="-striped"
          showPageSizeOptions={false}
          showPaginationBottom={false}
          noDataText=""
          defaultSorted={
            ([
              {
                id: "name",
                desc: false
              }
            ],
            [
              {
                id: "fullName",
                desc: false
              }
            ],
            [
              {
                id: "userName",
                desc: false
              }
            ])
          }
        />
      </TableContainer>
    );
  }
}

export default Table;

const TableContainer = styled.div`
  .ReactTable {
    background: #fff;
    border: solid 1px #eaedf3;
    border-radius: 2px;

    .rt-table {
      .rt-thead {
        &.-header {
          border-bottom: solid 1px #eaedf3;
        }

        .rt-tr {
          display: flex;
          align-items: center;

          .rt-th {
            font-size: 15px;
            font-weight: 500;
            color: #3e3f42;
            padding: 10px;
          }
        }
      }

      .rt-tbody {
        .rt-tr-group {
          border-bottom: solid 1px #eaedf3;

          .rt-tr {
            display: flex;
            align-items: center;
            padding: 10px;
          }
        }
      }
    }

    .-loading {
      &:not(.-active) {
        display: none;
      }
    }
  }
`;
